import React, { useEffect } from 'react';
import { pick, get } from 'lodash';
import { Card, Form, Input, Loader, Button, Icon } from 'components';
import { withForm, withFormValidation } from 'hoc';
import { useSelect, useAction } from 'hooks';
import { EXTENSION_NAME_OPTIONS, GENDER_OPTIONS } from '../../constants';
import SelectRegion from '../address/SelectRegion';
import SelectProvince from '../address/SelectProvince';
import SelectMunicipality from '../address/SelectMunicipality';
import BarangaySelect from '../address/SelectBarangay';
import { useHistory } from 'react-router-dom';
// import Avatar from '../assets/images/pic.png';

const initState = {
  email: '',
  password: '',
  password_confirmation: '',
  first_name: '',
  middle_name: '',
  extension_name: '',
  last_name: '',
  gender: '',
  birth_date: '',
  terms_and_condition: '',
  mobile_number: '',
  region_id: '',
  province_id: '',
  municipality_id: '',
  barangay_id: '',
  street: '',
  tin_number: '',
  mailing_region_id: '',
  mailing_province_id: '',
  mailing_municipality_id: '',
  mailing_barangay_id: '',
  mailing_street: ''
}

const ContainerProfile = ({  onChange, onSetForm , value, helperMessage, isPassed }) => {

  const history = useHistory()
  const gettingProfile = useSelect('loading.isLoading', { type: 'auth.getProfile' });  
  const profile = useSelect('auth.profile');
  const user = useSelect('auth.user');
  const updateProfile = useAction('auth.updateProfile')
  const updatingProfile = useSelect('loading.isLoading', { type: 'auth.updateProfile' });  
  
  useEffect(() => {
    window.scroll({
      top: 0, 
      left: 0, 
      behavior: 'smooth'
    });
  }, [])

  useEffect(() => {
    onSetForm({
      ...initState,
      ...get(pick(profile, 'attributes'), 'attributes'),
      ...get(pick(user, 'attributes'), 'attributes')
    })
    // eslint-disable-next-line
  }, [gettingProfile])

  if(gettingProfile){
    return (
      <Card>
        <Card.Header>
          <b className="title">Profile</b>
        </Card.Header>
        <Card.Body>
          <div className="flex -mt-5">
            <div className="w-full xl:w-1/4 lg:w-1/4 flex p-5 border-r-0 xl:border-r-2 lg:border-r-2 border-gray-300  justify-center">
              <ul>
                <li className="flex space-x-3">
                  <span className="border w-5 h-5 border-primary rounded-full flex items-center justify-center">
                    <Icon.User />
                  </span>
                  <span >General Information</span>
                </li>
              </ul>
            </div>
            <div className="flex-1 p-5">
              <Loader.Table />
            </div>
          </div>
        </Card.Body>
      </Card>
    )
  }

  const handleUpdateProfile = e => {
    e.preventDefault()
    updateProfile(value, () => {
      history.push('/')
    })
  }
  
  return (
    <Card>
      <Card.Header>
        <b className="title">Profile</b>
      </Card.Header>
      <Card.Body>
        <div className="flex flex-col xl:flex-row lg:flex-row -mt-5">
          <div className="w-full xl:w-1/4 lg:w-1/4 flex p-5 border-r-0 xl:border-r-2 lg:border-r-2 border-gray-300  justify-center">
            <ul>
              <li className="flex space-x-3">
                <span className="border w-5 h-5 border-primary rounded-full flex items-center justify-center">
                  <Icon.User />
                </span>
                <span >General Information</span>
              </li>
            </ul>
          </div>
          <div className="flex-1 p-5 ">
            <Form onSubmit={handleUpdateProfile}>
              <Form.FormGroup className="form-group-3">
                <Input label="First Name" name="first_name" onChange={onChange} value={value.first_name} helperMessage={helperMessage}/>
                <Input label="Middle Name" name="middle_name" onChange={onChange} value={value.middle_name} helperMessage={helperMessage}/>
                <Input label="Last Name" name="last_name" onChange={onChange} value={value.last_name} helperMessage={helperMessage}/>
                
                
              </Form.FormGroup>
              <Form.FormGroup className="form-group-3">
                <Input type="select" options={EXTENSION_NAME_OPTIONS} label="Extension Name" name="extension_name" onChange={onChange} value={value.extension_name} helperMessage={helperMessage}/>
                <Input label="Email" name="email" onChange={onChange} value={value.email} helperMessage={helperMessage}/>
                <Input type="mask" mask="99999999999" placeholder="09000000000" label="Mobile Number" name="mobile_number" onChange={onChange} value={value.mobile_number} helperMessage={helperMessage}/>
                
              </Form.FormGroup>
              <Form.FormGroup className="form-group-3">
                <Input type="select" options={GENDER_OPTIONS} label="Gender" name="gender" onChange={onChange} value={value.gender} helperMessage={helperMessage}/>
                <Input label="Birth Date" maxDate={new Date()}  type="date" name="birth_date" onChange={onChange} value={value.birth_date} helperMessage={helperMessage}/>
                <Input type="mask" mask="999-999-999-99999" placeholder='---_---_---_-----' label="TIN Number" name="tin_number" onChange={onChange} value={value.tin_number} helperMessage={helperMessage}/>
              </Form.FormGroup>
              
              <span className="text-success text-sm font-bold">Mailing Address</span>
              <Form.FormGroup className="form-group-4">
                <SelectRegion 
                  prefixName="mailing_" 
                  onChange={onChange} 
                  value={value.mailing_region_id} 
                  helperMessage={helperMessage}/>
                <SelectProvince 
                  prefixName="mailing_" 
                  region_id={value.mailing_region_id} 
                  onChange={onChange} 
                  value={value.mailing_province_id} 
                  helperMessage={helperMessage}/>
                <SelectMunicipality 
                  prefixName="mailing_" 
                  region_id={value.mailing_region_id} 
                  province_id={value.mailing_province_id} 
                  onChange={onChange} 
                  value={value.mailing_municipality_id} 
                  helperMessage={helperMessage} />
                <BarangaySelect 
                  prefixName="mailing_" 
                  region_id={value.mailing_region_id} 
                  province_id={value.mailing_province_id} 
                  municipality_id={value.mailing_municipality_id} 
                  onChange={onChange} 
                  value={value.mailing_barangay_id} 
                  helperMessage={helperMessage}/>
              </Form.FormGroup>
              <Form.FormGroup className="form-group">
                <Input label="Unit/Room number/Floor, Building Name, House number, Street
                      name." name="mailing_street" onChange={onChange} value={value.mailing_street} helperMessage={helperMessage}/>
              </Form.FormGroup>
              <span className="text-success text-sm font-bold">Business Address</span>
              <Form.FormGroup className="form-group-4">
                <SelectRegion onChange={onChange} value={value.region_id} helperMessage={helperMessage}/>
                <SelectProvince region_id={value.region_id} onChange={onChange} value={value.province_id} helperMessage={helperMessage}/>
                <SelectMunicipality region_id={value.region_id} province_id={value.province_id} onChange={onChange} value={value.municipality_id} helperMessage={helperMessage} />
                <BarangaySelect region_id={value.region_id} province_id={value.province_id} municipality_id={value.municipality_id} onChange={onChange} value={value.barangay_id} helperMessage={helperMessage}/>
              </Form.FormGroup>
              <Form.FormGroup className="form-group">
                <Input label="Unit/Room number/Floor, Building Name, House number, Street
                      name." name="street" onChange={onChange} value={value.street} helperMessage={helperMessage}/>
              </Form.FormGroup>
              <div className="flex justify-start items-center pt-5">
                <Button disabled={!isPassed} isLoading={updatingProfile} className="!w-auto">Submit</Button>
              </div>
            </Form>
          </div>
        </div>
      </Card.Body>
    </Card>
  )
}


export default withForm(withFormValidation(ContainerProfile, 
  {
    email: 'required|email',
    first_name: 'required',
    last_name: 'required',
    mobile_number: 'required|mobile_number',
    gender: 'required',
    birth_date: 'required|date',
  },
), initState);